"use client";

import { useFeatureFlagEnabled, usePostHog } from "posthog-js/react";
import { ROUTES } from "@/lib/constants";

const HERO_ANNOUNCEMENT_FLAG = "hero-announcement-chip-residential";

interface HeroAnnouncement {
  href: string;
  label: string;
  badge?: string;
}

const MCP_ANNOUNCEMENT: HeroAnnouncement = {
  href: "/tools/mcp-server",
  label: "Our MCP server is here",
};
const RESIDENTIAL_ANNOUNCEMENT: HeroAnnouncement = {
  href: ROUTES.productResidentialProxies,
  label: "Explore our residential proxies",
  badge: "Also available",
};

type HeroAnnouncementLocation = "homepage" | "mobile-proxies-hero";

/* A/B tests the hero announcement chip (50/50, `hero-announcement-chip-residential`):
   control keeps the MCP server badge, the variant cross-sells residential proxies.
   Centralised here because the homepage and Mobile Proxies heroes both need the
   exact same flag check, copy, and click tracking. */
export function useHeroAnnouncementChip(location: HeroAnnouncementLocation) {
  const posthog = usePostHog();
  const residentialVariant = useFeatureFlagEnabled(HERO_ANNOUNCEMENT_FLAG) === true;
  const announcement = residentialVariant ? RESIDENTIAL_ANNOUNCEMENT : MCP_ANNOUNCEMENT;

  const onAnnouncementClick = () =>
    posthog?.capture("hero_announcement_chip_clicked", {
      variant: residentialVariant ? "residential" : "control",
      location,
    });

  return { announcement, onAnnouncementClick };
}
